import { z } from 'zod';

// Shared primitive schemas reused across entities.

export const uuidSchema = z.string().uuid();
export type UUID = z.infer<typeof uuidSchema>;

export const isoDateTimeSchema = z.string().datetime({ offset: true });
export type IsoDateTime = z.infer<typeof isoDateTimeSchema>;

export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
export type IsoDate = z.infer<typeof isoDateSchema>;

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email()
  .max(254, 'Email exceeds maximum length');

export const phoneSchema = z
  .string()
  .trim()
  .regex(/^\+?[0-9\s().-]{7,20}$/, 'Phone number format is not recognised');

// Soft-delete + audit fields present on every family-facing entity.
export const timestampedSchema = z.object({
  id: uuidSchema,
  created_at: isoDateTimeSchema,
  updated_at: isoDateTimeSchema,
});

export const softDeletableSchema = timestampedSchema.extend({
  deleted_at: isoDateTimeSchema.nullable(),
});

// Used in paginated list responses.
export const paginationSchema = z.object({
  page: z.number().int().nonnegative(),
  pageSize: z.number().int().positive().max(200),
  total: z.number().int().nonnegative(),
});
export type Pagination = z.infer<typeof paginationSchema>;
